<script type="text/javascript">
	import { onMount, onDestroy, setContext } from "svelte";
	import { get } from "svelte/store";
	import Textfield, { Input, Textarea } from "@smui/textfield";
	import moment from "moment";

	import LoadingStore from "../LoadingStore";
	import LoadState from "../Enums/LoadState";
	import NOTAMStore from "./NOTAMStore";
	import RequireAGOL from "../UI/AGOL/RequireAGOL.svelte";
	import ModalWindow from "../UI/ModalWindow.svelte";
	import NOTAMSTable from "./NOTAMSTable.svelte";
	import NOTAMActiveState from "./NOTAMActiveState";
	import MapStore from "../Map/Store";
	import PopupStore from "../Map/Popup/PopupStore";
	import OAuthStore from "../OAuth/Store";
	import AuthState from "../Auth/Enums/AuthState";

	import "../UI/LayerList/LayerList.scss";
	import LayerListSwitch from "../UI/LayerList/LayerListSwitch.svelte";

	import Spinner from "../UI/Spinner/Spinner.svelte";
	import SpinnerSize from "../UI/Spinner/SpinnerSize";

	let visible = NOTAMStore.meta.visible;
	let loadState = NOTAMStore.meta.loadState;

	let authState = OAuthStore.configs.agol.authState;

	let open = false;
	let currentGroup = NOTAMStore.results.currentGroup;

	let notams = NOTAMStore.results.notamsFiltered;
	let lastUpdated = NOTAMStore.meta.lastUpdated;
	let filterString = NOTAMStore.filters.filterString;
	$: {
		if ($visible && $authState === AuthState.LOGGED_IN) { // User.hasFeature(Feature.NOTAMS.VIEW)
			NOTAMStore.actions.init();

			const map = get(MapStore.mapbox.instance);
			const mapInitialised = get(MapStore.meta.initialised);

			if (map && mapInitialised) {
				let onNOTAMLayerClick = (e) => {
					e.preventDefault();

					if (!open) {
						//console.log("features", e.features);

						let notams = [];
						for (let i = 0; i < e.features.length; i++) {
							const clickedFeature = e.features[i];

							console.log("location", clickedFeature.properties.location);
							console.log("id2", clickedFeature.properties.ID2);
							const group = NOTAMStore.helpers.findByProperty("globalId", clickedFeature.properties.GlobalID);
							if (!group) {
								console.warning("could not find notam group");
								return;
							}
							notams = [
								...notams,
								...group.properties.notams
							];
						}
						notams.sort((one,two) => { // Sort by newest at the top.
							return two.dateStart - one.dateStart;
						});
						$currentGroup = notams; //clickedForNOTAMs;
						open = true;
					}
				 	// TODO: make the modal window content div scroll back to the top
				};

				let onNOTAMLayerEnter = (e) => {
			  		map.getCanvas().style.cursor = 'pointer';
			  		if (e.features.length > 0) {
				 		//const group = SanctionStore.helpers.findByCountryName(e.features[0].properties.StateName);
						//if (group) {
						//	const sanctions = group.properties.sanctions;
							const coords = [e.lngLat.lng, e.lngLat.lat]; // GeoHelper.calcCenter(e.features[0]);

							let html = "";
							html += `<strong>NOTAMs - ${e.features[0].properties.StateName} - ${e.features[0].properties.ID2}</strong><br/>`;
							html += "<i>Click to view</i>";

							PopupStore.actions.customHtml(html, 400, coords, true);
						//}
					}
				};
				let onNOTAMLayerLeave = (e) => {
			  		map.getCanvas().style.cursor = MapStore.helpers.getDefaultCursor();
			  		PopupStore.actions.custom({}, null, false);
				};

				map.on("click", NOTAMStore.meta.dataLayerName, onNOTAMLayerClick);
				map.on("mouseenter", NOTAMStore.meta.dataLayerName, onNOTAMLayerEnter);
				map.on("mousemove", NOTAMStore.meta.dataLayerName, onNOTAMLayerEnter);
				map.on("mouseleave", NOTAMStore.meta.dataLayerName, onNOTAMLayerLeave);
			}

		}
		$lastUpdated;
		$currentGroup = $currentGroup;
		NOTAMStore.actions.updateVisibility();
	}

	onMount(()=>{
		return LoadingStore.onMount("NOTAMS", loadState);
	});

	let oldActive = NOTAMStore.filters.activeState[NOTAMActiveState.PAST];
	let curActive = NOTAMStore.filters.activeState[NOTAMActiveState.CURRENT];
	let futActive = NOTAMStore.filters.activeState[NOTAMActiveState.FUTURE];

	$: {
		$oldActive;
		$curActive;
		$futActive;
		NOTAMStore.actions.updateFilters();
	}

	let dateFormat = "MMMM Do YYYY, hh:mm:ssa [(UTC)]";

</script>

<ModalWindow
	title={`NOTAMs`}
	materialIcon={"flight"}
	hasCloseButton={true}
	hasBackground={false}
	resizable={true}
	draggable={true}
	fullscreen={false}
	padding={true}
	position="top-right"
	height="70%"
	bind:open={$visible}>

	{#if $loadState === LoadState.LOADING}
		<div class="spinner-center">
			<Spinner size={SpinnerSize.SMALL} absolute={false} inline={true} />
		</div>
	{/if}

	<RequireAGOL>
		{#if $loadState === LoadState.LOADED}
			<p class="fw-b mt-5 mb-5">Layers</p>
			<div class='layer-list-component'>
				<LayerListSwitch label={NOTAMActiveState.PAST} bind:checked={$oldActive} />
				<LayerListSwitch label={NOTAMActiveState.CURRENT} bind:checked={$curActive} />
				<LayerListSwitch label={NOTAMActiveState.FUTURE} bind:checked={$futActive} />
			</div>
			<p class="fw-b mt-10 mb-0">List</p>
			<Textfield fullwidth dense variant="filled" label="Filter NOTAMs..."
					bind:value={$filterString}/>

			<NOTAMSTable notams={$notams} height={300} filterString={$filterString}/>
		{/if}
	</RequireAGOL>
</ModalWindow>

{#if $loadState === LoadState.LOADED}
	{#if open && $currentGroup}
		<ModalWindow
			materialIcon={"flight"}
			title={"NOTAMs - " + $currentGroup[0].country + " - " + $currentGroup[0].location}
			hasCloseButton={true}
			bind:open={open}>

			{#each $currentGroup as notam, index}
				{#if notam.visible}
					<div style="border-bottom:1px solid #ddd">

						<h2><b>{notam.qcode}</b> - {notam.country}</h2>
						<!-- {(notam.country.length>0)?" - ":""} {notam.id2} -->
						<h2 style={"color:" + notam.color}>{notam.activeStateState}</h2>
						{#if notam.message !== "N/A"}
							<p>{@html notam.message}</p>
						{/if}
						<p><b>Start:</b> {moment(notam.dateStart).format(dateFormat)}</p>
						<p><b>End:</b> {moment(notam.dateEnd).format(dateFormat)}</p>

					</div>
				{/if}
			{/each}
		</ModalWindow>
	{/if}
{/if}
